import React from "react";
import { images } from "../mock";
import { Globe2 } from "lucide-react";

const Relocate = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1">
          <div className="inline-flex items-center gap-2 text-sm font-medium text-[color:var(--brand-teal)] uppercase tracking-wider">
            <Globe2 size={18} />
            Expert Door-to-Door International Moving
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold mt-4 leading-tight">
            RELOCATE WITH <span className="text-[color:var(--brand-red)]">CONFIDENCE</span>,
            <br />
            ANYWHERE IN THE WORLD!
          </h2>
          <div className="h-1 w-16 bg-[color:var(--brand-red)] mt-4 mb-6" />
          <p className="text-gray-700 leading-relaxed">
            At <span className="font-semibold text-[color:var(--brand-red)]">ERM CARGO & PACKAGING LLC</span> we&apos;re not just moving boxes; we&apos;re moving lives and memories. Our unique, innovative approach ensures every detail, from meticulous packing to navigating complex customs, is handled with utmost care.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            We promise unparalleled peace of mind, delivering your cherished possessions safely and on time. Let us turn your daunting international move into an exciting new chapter with our personalized, professional service.
          </p>

          <a
            href="#contact"
            className="btn-red inline-block font-display uppercase tracking-wider px-8 py-3 rounded text-sm mt-8"
          >
            Start Your Journey
          </a>
        </div>

        <div className="order-1 md:order-2 relative">
          <div className="absolute -top-4 -right-4 w-full h-full border-2 border-[color:var(--brand-teal)] rounded-sm" />
          <img
            src={images.relocate}
            alt="International relocation"
            className="relative w-full h-[460px] object-cover rounded-sm shadow-xl"
          />
        </div>
      </div>
    </section>
  );
};

export default Relocate;
